/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../../_chunks/dep-be6b014c.mjs';
import { _ as _defineProperty } from '../../../_chunks/dep-fa22eda7.mjs';
import { isVNode, defineComponent, ref, watch, createVNode, mergeProps } from 'vue';
import '../../../_chunks/dep-34428f12.mjs';
import { a as _createCompounder } from '../../../_chunks/dep-84053b94.mjs';
import props from '../../props.mjs';
import { FORMATS } from '../../const.mjs';
import { Select, Option } from '../../../select/index.mjs';
import FormatInputs from './inputs.mjs';
import { useBaseClassName } from '../../hooks.mjs';
import '../../../_chunks/dep-558fadc3.mjs';
import '../../../_chunks/dep-8a0ff305.mjs';
import '../../../_chunks/dep-2a69909d.mjs';
import '../../../_chunks/dep-1c40d002.mjs';
import '../../../_chunks/dep-e9ff4ce8.mjs';
import '../../../_chunks/dep-c54c9f32.mjs';
import '../../../_chunks/dep-c24f5c5d.mjs';
import '../../../_chunks/dep-61150968.mjs';
import '../../../_common/js/color-picker/constants.mjs';
import '../../../select/select.mjs';
import '../../../_chunks/dep-b9505f3d.mjs';
import '../../../_chunks/dep-1ec078b3.mjs';
import '../../../_chunks/dep-e524ff2f.mjs';
import '../../../_chunks/dep-16b9f817.mjs';
import '../../../_chunks/dep-0bf03d55.mjs';
import '../../../_chunks/dep-5b5daf08.mjs';
import '../../../_chunks/dep-1f286011.mjs';
import '../../../_chunks/dep-3ced59c9.mjs';
import '../../../_chunks/dep-95049222.mjs';
import '../../../_chunks/dep-ac19a2b6.mjs';
import '../../../_chunks/dep-6c1f8553.mjs';
import '../../../_chunks/dep-90d97bcb.mjs';
import '../../../_chunks/dep-c8679a16.mjs';
import '../../../_chunks/dep-e09a06d8.mjs';
import '../../../_chunks/dep-939a74d6.mjs';
import '../../../_chunks/dep-45572c49.mjs';
import '../../../_chunks/dep-437754aa.mjs';
import '../../../_chunks/dep-6dbd6c24.mjs';
import '../../../_chunks/dep-0f45a6e0.mjs';
import '../../../_chunks/dep-25b8bf4b.mjs';
import '../../../_chunks/dep-a861ee00.mjs';
import '../../../_chunks/dep-3514a375.mjs';
import '../../../_chunks/dep-4371fb57.mjs';
import '../../../_chunks/dep-31d34e52.mjs';
import '../../../_chunks/dep-67e8723b.mjs';
import '../../../_chunks/dep-e4f65bc4.mjs';
import '../../../_chunks/dep-1aa18f5f.mjs';
import '../../../_chunks/dep-07f3660d.mjs';
import '../../../_chunks/dep-0d3220b0.mjs';
import '../../../_chunks/dep-895678a0.mjs';
import '../../../_chunks/dep-b2bdc7b9.mjs';
import '../../../_chunks/dep-154ff253.mjs';
import '../../../_chunks/dep-e583fb66.mjs';
import '../../../_chunks/dep-a059cf4b.mjs';
import '../../../_chunks/dep-54378e60.mjs';
import '../../../common-components/fake-arrow.mjs';
import '../../../hooks/useConfig.mjs';
import '../../../config-provider/useConfig.mjs';
import '../../../_chunks/dep-b390ff23.mjs';
import '../../../_chunks/dep-35a4fd8d.mjs';
import '../../../_chunks/dep-c40264c0.mjs';
import '../../../_chunks/dep-9d499243.mjs';
import '../../../_common/js/global-config/default-config.mjs';
import '../../../_common/js/global-config/locale/zh_CN.mjs';
import '../../../_chunks/dep-0927ceb7.mjs';
import '../../../_chunks/dep-f0bd05df.mjs';
import '../../../config-provider/type.mjs';
import '../../../select-input/index.mjs';
import '../../../select-input/select-input.mjs';
import '../../../popup/index.mjs';
import '../../../popup/popup.mjs';
import '@popperjs/core';
import '../../../hooks/index.mjs';
import '../../../hooks/icon.mjs';
import '../../../hooks/slot.mjs';
import '../../../hooks/tnode.mjs';
import '../../../_chunks/dep-c25d13e7.mjs';
import '../../../_chunks/dep-79d42d5d.mjs';
import '../../../_chunks/dep-979d7716.mjs';
import '../../../_chunks/dep-8b3be089.mjs';
import '../../../_chunks/dep-398227bb.mjs';
import '../../../utils/render-tnode.mjs';
import '../../../_chunks/dep-55311368.mjs';
import '../../../hooks/useCommonClassName.mjs';
import '../../../hooks/useDefaultValue.mjs';
import '../../../hooks/useDestroyOnClose.mjs';
import '../../../hooks/useKeepAnimation.mjs';
import '../../../hooks/useRipple.mjs';
import '../../../utils/set-style.mjs';
import '../../../hooks/useVirtualScroll.mjs';
import '../../../hooks/useVModel.mjs';
import '../../../hooks/useImagePreviewUrl.mjs';
import '../../../_common/js/upload/utils.mjs';
import '../../../_common/js/log/log.mjs';
import '../../../utils/dom.mjs';
import '../../../utils/easing.mjs';
import '../../../_common/js/utils/set-style.mjs';
import '../../../popup/container.mjs';
import '../../../popup/props.mjs';
import '../../../hooks/useResizeObserver.mjs';
import '../../../utils/withInstall.mjs';
import './style/css.mjs';
import '../../../popup/type.mjs';
import '../../../select-input/props.mjs';
import '../../../select-input/useSingle.mjs';
import '../../../input/index.mjs';
import '../../../input/input.mjs';
import 'tdesign-icons-vue-next';
import '../../../input/props.mjs';
import '../../../form/hooks.mjs';
import '../../../hooks/useGlobalIcon.mjs';
import '../../../input/useInput.mjs';
import '../../../form/const.mjs';
import '../../../input/useLengthLimit.mjs';
import '../../../_common/js/log/index.mjs';
import '../../../_common/js/utils/helper.mjs';
import '../../../_chunks/dep-51567b45.mjs';
import '../../../_chunks/dep-9a7888c7.mjs';
import '../../../_chunks/dep-af8c0169.mjs';
import '../../../input/useInputEventHandler.mjs';
import '../../../input/useInputWidth.mjs';
import '../../../input/input-group.mjs';
import '../../../input/input-group-props.mjs';
import '../../../input/type.mjs';
import '../../../loading/index.mjs';
import '../../../loading/directive.mjs';
import '../../../loading/plugin.mjs';
import '../../../loading/loading.mjs';
import '../../../loading/icon/gradient.mjs';
import '../../../_common/js/loading/circle-adapter.mjs';
import '../../../loading/props.mjs';
import '../../../hooks/useTeleport.mjs';
import '../../../loading/type.mjs';
import '../../../select-input/useMultiple.mjs';
import '../../../tag-input/index.mjs';
import '../../../tag-input/tag-input.mjs';
import '../../../tag-input/props.mjs';
import '../../../tag-input/hooks/useTagScroll.mjs';
import '../../../tag-input/useTagList.mjs';
import '../../../tag/index.mjs';
import '../../../tag/tag.mjs';
import '../../../tag/props.mjs';
import '../../../tag/check-tag.mjs';
import '../../../tag/check-tag-props.mjs';
import '../../../tag/type.mjs';
import '../../../tag-input/hooks/useHover.mjs';
import '../../../tag-input/hooks/useDragSorter.mjs';
import '../../../tag-input/type.mjs';
import '../../../select-input/useOverlayInnerStyle.mjs';
import '../../../select-input/type.mjs';
import '../../../select/select-panel.mjs';
import '../../../_chunks/dep-ad4331e8.mjs';
import '../../../_chunks/dep-e40749a5.mjs';
import '../../../select/option.mjs';
import '../../../select/option-props.mjs';
import '../../../checkbox/index.mjs';
import '../../../checkbox/checkbox.mjs';
import '../../../checkbox/props.mjs';
import '../../../checkbox/constants.mjs';
import '../../../checkbox/hooks/useCheckboxLazyLoad.mjs';
import '../../../_common/js/utils/observe.mjs';
import '../../../checkbox/hooks/useKeyboard.mjs';
import '../../../hooks/useDisabled.mjs';
import '../../../_chunks/dep-44e322cb.mjs';
import '../../../checkbox/group.mjs';
import '../../../checkbox/checkbox-group-props.mjs';
import '../../../checkbox/type.mjs';
import '../../../select/helper.mjs';
import '../../../select/optionGroup.mjs';
import '../../../select/option-group-props.mjs';
import '../../../select/props.mjs';
import '../../../select/hooks/usePanelVirtualScroll.mjs';
import '../../../select/hooks/useSelectOptions.mjs';
import '../../../select/type.mjs';
import '../../../_chunks/dep-3bc637e0.mjs';
import '../../utils/index.mjs';
import '../../../_common/js/color-picker/index.mjs';
import '../../../_common/js/color-picker/cmyk.mjs';
import '../../../_common/js/color-picker/color.mjs';
import '../../../_chunks/dep-c6ef2029.mjs';
import '../../../_chunks/dep-9f8df9b5.mjs';
import '../../../_common/js/color-picker/draggable.mjs';
import '../../../input-number/index.mjs';
import '../../../input-number/input-number.mjs';
import '../../../button/index.mjs';
import '../../../button/button.mjs';
import '../../../button/props.mjs';
import '../../../button/type.mjs';
import '../../../input-number/props.mjs';
import '../../../input-number/useInputNumber.mjs';
import '../../../_common/js/input-number/number.mjs';
import '../../../_common/js/input-number/large-number.mjs';
import '../../../input-number/type.mjs';
import './config.mjs';

var createCompounder = _createCompounder;

/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = createCompounder(function (result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});
var upperCase_1 = upperCase;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !isVNode(s);
}
var FormatPanel = defineComponent({
  name: "FormatPanel",
  inheritAttrs: false,
  props: _objectSpread(_objectSpread({}, props), {}, {
    color: {
      type: Object
    },
    onModeChange: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    },
    onInputChange: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    }
  }),
  setup: function setup(props2) {
    var baseClassName = useBaseClassName();
    var formatModel = ref(props2.format);
    watch(function () {
      return [props2.format];
    }, function () {
      return formatModel.value = props2.format;
    });
    var handleModeChange = function handleModeChange(v) {
      formatModel.value = v;
      props2.onModeChange(v);
    };
    return {
      formatModel: formatModel,
      baseClassName: baseClassName,
      handleModeChange: handleModeChange
    };
  },
  render: function render() {
    var _this = this;
    var _slot;
    var formats = _toConsumableArray(FORMATS);
    var baseClassName = this.baseClassName,
      handleModeChange = this.handleModeChange;
    var newProps = _objectSpread(_objectSpread({}, this.$props), {}, {
      format: this.formatModel
    });
    var selectInputProps = _objectSpread({}, this.selectInputProps || {});
    return createVNode("div", {
      "class": "".concat(baseClassName, "__format")
    }, [createVNode("div", {
      "class": "".concat(baseClassName, "__format--item")
    }, [createVNode(Select, mergeProps({
      "size": "small",
      "class": "".concat(baseClassName, "__format-mode-select")
    }, selectInputProps, {
      "popupProps": _objectSpread({
        overlayClassName: "".concat(baseClassName, "__select-options")
      }, selectInputProps.popupProps),
      "modelValue": _this.formatModel,
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _this.formatModel = $event;
      },
      "onChange": handleModeChange
    }), _isSlot(_slot = formats.map(function (item) {
      return createVNode(Option, {
        "key": item,
        "value": item,
        "label": upperCase_1(item),
        "style": {
          fontSize: "12px"
        }
      }, null);
    })) ? _slot : {
      "default": function _default() {
        return [_slot];
      }
    })]), createVNode("div", {
      "class": "".concat(baseClassName, "__format--item")
    }, [createVNode(FormatInputs, newProps, null)])]);
  }
});

export { FormatPanel as default };
//# sourceMappingURL=index.mjs.map
